// OEM App 定制 — 构建相关常量与工具
import { PLATFORM_LABEL, REGION_LABEL } from './materialConfig';

export const STAGE_NAME = { phase1: '一阶段', phase2: '二阶段' };
export const STAGE_VERSION = { phase1: 'v0.9.0', phase2: 'v1.0.0' };
export const STAGE_DATA_KEY = { phase1: 'p1', phase2: 'p2' };

export const BUILD_LOGS = [
    '[1/4] 拉取代码仓库完成（main@a3f91c2）',
    '[2/4] 依赖安装完成（npm ci，耗时 42s）',
    '[3/4] 代码编译完成（0 error，12 warning）',
    '[4/4] 各平台打包 & 签名完成 ✓',
];

// 展开「平台 × 区域」为构建任务
export const buildJobs = (record) => {
    const jobs = [];
    (record?.targets || []).forEach((t) => {
        const regions = Array.isArray(t.regions) ? t.regions : (t.regions ? [t.regions] : []);
        regions.forEach((rg) => jobs.push({
            key: `${t.platform}-${rg}`,
            label: `${PLATFORM_LABEL[t.platform] || t.platform} · ${REGION_LABEL[rg] || rg}`,
            artifact: t.platform === 'ios' ? 'IPA' : 'APK',
        }));
    });
    return jobs;
};

export const buildLabel = (st, stage) => (st === 'done' ? `查看${STAGE_NAME[stage]}产物`
    : st === 'failed' ? `${STAGE_NAME[stage]}构建失败`
        : st === 'building' ? `${STAGE_NAME[stage]}进度`
            : `构建${STAGE_NAME[stage]}`);

export const isStageFull = (stage, r) => {
    const s = r?.[STAGE_DATA_KEY[stage]] || {};
    return s.total > 0 && s.done >= s.total;
};

// 预置构建状态（示例数据）：{ `${id}:${stage}`: 'building' | 'done' | 'failed' }
// - building：构建中，列表阶段列显示「一/二阶段进度」
// - done：构建完成，列表阶段列显示「查看一/二阶段产物」
// - failed：构建失败，列表阶段列显示「一/二阶段构建失败」（红）
export const INITIAL_BUILD_STATES = {
    'OEM-1002:phase1': 'building',
    'OEM-1007:phase1': 'done',
    'OEM-1005:phase1': 'failed',
    'OEM-1008:phase1': 'done',
    'OEM-1008:phase2': 'done',
    'OEM-1009:phase1': 'done',
};
